import React from 'react';
import withWrapper from '../withWrapper';
export default withWrapper('Edit', function (props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", null, React.createElement("g", {
    transform: "translate(6.000000, 6.000000)",
    stroke: props.outStrokeColor,
    strokeLinejoin: props.strokeLinejoin,
    strokeWidth: props.strokeWidth
  }, React.createElement("path", {
    d: "M1,36 L37,36",
    strokeLinecap: props.strokeLinecap
  }), React.createElement("polygon", {
    fill: props.outFillColor,
    fillRule: "nonzero",
    points: "5 20.7198497 5 28 12.3171881 28 33 7.30814278 25.6950519 0"
  })))));
});